import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import ContentCopyIcon from '@material-ui/icons/FileCopy';
import ContentPasteIcon from '@material-ui/icons/Assignment';
import ImportExportIcon from '@material-ui/icons/ImportExport';

import DataTableToolbar from '../../../_Shared/DataTables/DataToolbar';
import Select from '../../../_Shared/SearchableDropdown';
import ImportQueryColumns from './ImportQueryColumns';

const _ = require('lodash');
const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    },
    head: {
        height: 50
    }
});

const types = ['Column'];
const dataTypes = [
    { Name: 'Fixed-length Text', Sql: 'char' },
    { Name: 'Variable-length Text', Sql: 'varchar' },
    { Name: 'Small Number', Sql: 'smallint' },
    { Name: 'Whole Number', Sql: 'int' },
    { Name: 'Big Number', Sql: 'bigint' },
    { Name: 'Decimal Number', Sql: 'decimal' },
    { Name: 'True / False', Sql: 'boolean' },
    { Name: 'Date / Time', Sql: 'datetime' }
];

class QueryColumn extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            column: props.column
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { column } = this.props;
        if (column !== null && !_.isEqual(prevProps.column, column)) {
            this.setState({ column: column });
        }
    }

    handleInputChange = (name, value, index) => {
        let { column } = this.state;

        let row = Object.assign({}, column);
        switch (value) {
            case 'decimal':
                row.scale = 20;
                row.maxLength = 32;
                row.isIdentity = false;
                row.defaultValue = '0';
                delete row.defaultValueIsFunction;
                break;
            case 'smallint':
            case 'int':
            case 'bigint':
                row.defaultValue = '0';
                delete row.scale;
                delete row.maxLength;
                delete row.defaultValueIsFunction;
                break;
            case 'char':
            case 'varchar':
                row.maxLength = 256;
                row.isIdentity = false;
                row.defaultValue = '';
                delete row.scale;
                delete row.defaultValueIsFunction;
                break;
            case 'datetime':
                row.isIdentity = false;
                row.defaultValue = 'CURRENT_DATE';
                row.defaultValueIsFunction = true;
                delete row.scale
                delete row.maxLength;
                break;
            case 'boolean':
                row.isIdentity = false;
                row.defaultValue = 'TRUE';
                delete row.scale
                delete row.maxLength;
                delete row.defaultValueIsFunction;
                break;
            default:
                break;
        }

        let editedColumn = Object.assign({}, row, { [name]: value });
        
        this.setState({ column: editedColumn });
        this.props.onEdit(editedColumn, index);
    }

    render() {
        const { rowIndex, columnChecked } = this.props;
        const { column } = this.state;
        return (<TableRow>
                    <TableCell padding="checkbox">
                        <Checkbox onChange={(e, c) => columnChecked(column, c, rowIndex)} />
                    </TableCell>
                    <TableCell>
                        <TextField value={column.order} onChange={e => this.handleInputChange('order', e.target.value, rowIndex)}
                            id="order" name="order" type="number" fullWidth />
                    </TableCell>
                    <TableCell>
                        <TextField value={column.name} onChange={e => this.handleInputChange('name', e.target.value, rowIndex)}
                            id="name" name="name" type="text" fullWidth />
                    </TableCell>
                    <TableCell>
                        <Select options={types.map(x => { return { 'label': x, 'value': x } })} value={column.type} name="type"
                            onChange={value => this.handleInputChange('type', value, rowIndex)} />
                    </TableCell>
                    <TableCell>
                        <Select options={dataTypes.map(x => { return { 'label': x.Name, 'value': x.Sql } })} value={column.dataType}
                            name="dataType" onChange={value => this.handleInputChange('dataType', value, rowIndex)} />
                    </TableCell>
                </TableRow>
        );
    }
}

class EditColumn extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedColumn: props.column
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { column } = this.props;
        if (column !== null && !_.isEqual(prevProps.column, column)) {
            this.setState({ selectedColumn: column });
        }
    }

    handleInputChange = (name, value, key) => {
        let { selectedColumn, selectedIndex } = this.state;

        let editedColumn = Object.assign({}, selectedColumn, { [name]: value });
        
        this.setState({ selectedColumn: editedColumn });
        this.props.onEdit(editedColumn, selectedIndex);
    }

    render() {
        const { selectedColumn } = this.state;

        return (<Grid item xs={5}>
                    <Grid container spacing={40}>
                        <Grid item lg={6} xl={6}>
                            <TextField value={selectedColumn.alias} id="alias" name="alias" type="text" label="Alias" fullWidth
                                onChange={e => this.handleInputChange('alias', e.target.value, selectedColumn.id)} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={40}>
                        <Grid item lg={6} xl={6}>
                            <TextField value={selectedColumn.defaultValue} id="defaultValue" name="defaultValue" type="text" label="Default value"
                                fullWidth onChange={e => this.handleInputChange('defaultValue', e.target.value, selectedColumn.id)} />
                        </Grid>
                    {
                        selectedColumn.hasOwnProperty('defaultValueIsFunction') && selectedColumn.defaultValueIsFunction !== null &&
                        <Grid item lg={6} xl={6}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Is function</FormLabel>
                                <FormGroup>
                                    <FormControlLabel control={
                                        <Switch checked={selectedColumn.defaultValueIsFunction}
                                            onChange={e => this.handleInputChange('defaultValueIsFunction', e.target.checked, selectedColumn.id)} />
                                    } />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                    }
                    </Grid>
                    <Grid container spacing={40}>
                    {
                        selectedColumn.maxLength &&
                        <Grid item lg={3} xl={3}>
                            <TextField value={selectedColumn.maxLength} id="maxLength" name="maxLength" type="number" label="Length" fullWidth
                                onChange={e => this.handleInputChange('maxLength', e.target.value, selectedColumn.id)} />
                        </Grid>
                    }
                    {
                        selectedColumn.scale &&
                        <Grid item lg={3} xl={3}>
                            <TextField value={selectedColumn.scale} id="scale" name="scale" type="text" label="Scale" fullWidth
                                onChange={e => this.handleInputChange('scale', e.target.value, selectedColumn.id)} />
                        </Grid>
                    }
                    </Grid>
                </Grid>
        );
    }
}

class QueryColumns extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            columnsChecked: [],
            selectedIndex: 0,
            openImportModal: false
        }
    }

    editColumn = (column, index) => {         
        this.props.onEditColumn(column, index);     
    }

    add = () => { 
        this.props.onAdd();
    }

    // delete = () => { }

    // copy = () => { }

    // paste = () => { }

    import = () => { 
        this.setState({ openImportModal: true });
    }

    closeImportModal = () => {
        this.setState((prevState) => {
            return { openImportModal: !prevState.openImportModal }
        });
    }

    column = () => {
        const { query: { columns } } = this.props;
        const { columnsChecked } = this.state;

        if (columnsChecked.length === 1) {
            let column = columns.find(x => x.id === columnsChecked[0]);
            return column;
        }

        return {};
    }

    columnChecked = (column, checked, index) => {
        const { columnsChecked } = this.state;

        if (checked) { columnsChecked.push(column.id); }
        else { columnsChecked.splice(column.id, 1); }

        this.setState({ columnsChecked, selectedIndex: index });
    }

    render() {
        const { classes, query, parentQueries } = this.props;
        const { selectedIndex, openImportModal } = this.state;
        const selectedColumn = this.column();

        return (<React.Fragment>
                    <DataTableToolbar title="" numSelected={0}>
                        {/* <Tooltip title="Copy"><IconButton onClick={this.copy} color="secondary"><ContentCopyIcon /></IconButton></Tooltip>
                        <Tooltip title="Paste"><IconButton onClick={this.paste} color="secondary"><ContentPasteIcon /></IconButton></Tooltip>
                        <Tooltip title="Delete"><IconButton onClick={this.delete} color="secondary"><DeleteIcon /></IconButton></Tooltip> */}
                        <Tooltip title="Import"><IconButton onClick={this.import} color="secondary"><ImportExportIcon /></IconButton></Tooltip>
                        <Tooltip title="Add New"><IconButton onClick={this.add} color="secondary"><AddCircleIcon /></IconButton></Tooltip>
                    </DataTableToolbar>
                    <Grid container spacing={24}>
                        <Grid item xs={7}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow classes={{ head: classes.head }}>
                                        <TableCell padding="checkbox"></TableCell>
                                        <TableCell>Order</TableCell>
                                        <TableCell style={{ width: '40%' }}>Name</TableCell>
                                        <TableCell style={{ width: '25%' }}>Type</TableCell>
                                        <TableCell style={{ width: '35%' }}>Data type</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {
                                    query.columns &&
                                    [].concat(query.columns).map((column, rowIndex) => 
                                    <QueryColumn column={column} key={`table_row_${rowIndex}`} rowIndex={rowIndex} onEdit={this.editColumn} columnChecked={this.columnChecked} />)
                                }
                                </TableBody>
                            </Table>
                        </Grid>
                    {
                        selectedColumn.id &&
                        <EditColumn column={selectedColumn} selectedIndex={selectedIndex} onEdit={this.editColumn} />
                    }
                    </Grid>
                {
                    parentQueries &&
                    <ImportQueryColumns open={openImportModal} onClose={this.closeExecutionHistory} parentQueries={parentQueries} />
                }
                </React.Fragment>
        );
    }
}

QueryColumns.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(QueryColumns);


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/QueryEditors/Common/QueryColumns.js